import { render } from "./indexMaritalStatusesComponent.vue?vue&type=template&id=3c678272"
import script from "./indexMaritalStatusesComponent.vue?vue&type=script&lang=js"
export * from "./indexMaritalStatusesComponent.vue?vue&type=script&lang=js"

import "./indexMaritalStatusesComponent.vue?vue&type=style&index=0&id=3c678272&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__